import React,{useState} from "react";
import { Link } from "react-router-dom";

import bg1 from "../assets/images/bg/who-we-are-about1.webp"
import about from "../assets/images/about.webp"
import about2 from "../assets/images/about02.jpg"
import about3 from "../assets/images/about03.webp"
import about4 from "../assets/images/about04.jpg"
import about5 from "../assets/images/about05.webp"
import cta from "../assets/images/cta.jpg"

import NavbarTwo from "../components/navbar/navbarTwo"
import ClientTwo from "../components/client/clientTwo";
import Partners from "../components/partners";
import Team from "../components/team";
import FooterThree from "../components/footer/footerThree";
import ScrollTop from "../components/scrollTop";

import ModalVideo from 'react-modal-video';
import '../../node_modules/react-modal-video/css/modal-video.css';

import {AiOutlineCheckCircle, FiAirplay, LiaReact, FiUsers,FiArrowRight} from '../assets/icons/vander'
import CountUp from 'react-countup';

export default function AboutUs(){
    const [isOpen, setOpen] = useState(false);
    const aboutData = [
        {
            icon:FiAirplay,
            title:'Developing strategy',
            desc:'It is said that song composers of the past used dummy texts as lyrics when writing to sing with the melody.'
        },
        {
            icon:LiaReact,
            title:'Blazing performance',
            desc:'It is said that song composers of the past used dummy texts as lyrics when writing to sing with the melody.'
        },
        {
            icon:FiUsers,
            title:'Customer satisfaction',
            desc:'It is said that song composers of the past used dummy texts as lyrics when writing to sing with the melody.'
        },
    ]
    const counterData = [
        {
            start:'0',
            end:'5458',
            title:'Investment Projects'
        },
        {
            start:'0',
            end:'15',
            title:'Years of Experience'
        },
        {
            start:'0',
            end:'54',
            title:'Offices in the World'
        },
        {
            start:'0',
            end:'214',
            title:'Successful Cases'
        },
    ]
    return(
        <>
        <NavbarTwo navClass="defaultscroll sticky" manuClass="navigation-menu nav-right nav-light"/>



        <section id="page-top" className="bg-half-170 d-table w-100" style={{backgroundImage:`url(${bg1})`, backgroundPosition:'center'}}>
            <div className="bg-overlay bg-gradient-overlay"></div>
            <div className="container">
                <div className="row justify-content-center pt-3 pb-0">
                    <div className="col-12">
                        <div className="title-heading text-center">
                            <h5 className="heading fw-semibold mb-0 page-heading text-white title-dark">This we believe...</h5>
                            <small className="text-white mb-1 fw-medium text-uppercase mx-auto">The truest measure of success lies in how deeply we help others succeed.</small>
                            
                        </div>
                    </div>
                </div>

                <div className="position-middle-bottom">
                    <nav aria-label="breadcrumb" className="d-block">
                        <ul className="breadcrumb breadcrumb-muted mb-0 p-0">
                            <li className="breadcrumb-item"><Link to="/">HOME</Link></li>
                            <li className="breadcrumb-item active" aria-current="page">WHO WE ARE</li>
                        </ul>
                    </nav>
                </div>
            </div>
        </section>
        <section className="section py-4">
            <div className="container">
                <div className="row align-items-center">
                    <div className="col-lg-10 col-md-6 mb-0" style={{width:'85%'}}>
                    <div className="section-title ms-lg-5">
                        <b><h3 className="text-muted2">About Us...</h3></b>
                        <p className="text-muted2">At Inclusive Family Insurance, we believe that insurance shouldn’t be confusing, impersonal, or one-size-fits-all. We offer tailored solutions that reflect the real lives and goals of the families we serve — with clear guidance, trustworthy options, and a commitment to long-term security. Whether you're seeking life, disability, or mortgage protection coverage, we’re here to simplify the process and make sure you feel supported every step of the way.</p>
                        </div></div><hr></hr></div></div></section>
        <section id="mission" className="section py-0">

            <div className="container">
                <div className="row align-items-center mt-3 mb-5">
                    
                    <div className="col-lg-5 col-md-6">
                        <img src={about} className="img-fluid rounded shadow" alt=""/>
                    </div>

                    <div className="col-lg-7 col-md-6 mt-4 pt-2 mt-sm-0 pt-sm-0">
                        <div className="section-title ms-lg-5">
                        <h3 className="title mb-3">Our Mission</h3>
                        <p className="text-muted2">To empower <b>everyone</b> to achieve financial security through fiscally responsible, tailored life insurance solutions.</p>
                            <ul className="list-unstyled text-muted2 mb-0">
                                <li className="mb-0"><span className="text-dark h5 me-2"><AiOutlineCheckCircle className="align-middle"/></span><span style={{ color:'#40403f' }}><b>Personalized Approach:</b></span> We seek to deeply understand each client's specific situation, ensuring our customized life and/or disability insurance solutions precisely match our client's needs and budget.</li>
                                <li className="mb-0"><span className="text-dark h5 me-2"><AiOutlineCheckCircle className="align-middle"/></span><span style={{ color:'#40403f' }}><b>Clarity and Confidence:</b></span> We simplify the complexity of insurance policies. Our clients secure policies they understand with all their questions answered.</li>
                                <li id="vision" className="mb-0"><span className="text-dark h5 me-2"><AiOutlineCheckCircle className="align-middle"/></span><span style={{ color:'#40403f' }}><b>Trusted Support:</b></span> We stand with all families to help them protect what matters most, through every stage of life.</li>
                            </ul>                        
                        </div>
                    </div>
                    
                </div><hr></hr>
                    

                <div id="vision" className="row align-items-center mt-5 mb-5">
                    <div className="col-lg-5 col-md-6">
                        <img src={about5} className="img-fluid rounded shadow" alt=""/>
                    </div>
                    <div className="col-lg-7 col-md-6 mt-4 pt-2 mt-sm-0 pt-sm-0">
                        <div className="section-title ms-lg-5">
                        <h3 className="title mb-3">Our Vision</h3>
                        <p className="text-muted2">We envision a world where financial security is accessible to everyone. We strive to empower all families by breaking down barriers, demystifying insurance and financial protection, and sharing the tools needed for lasting protection and prosperity.</p>
                            <ul className="list-unstyled text-muted2 mb-0">
                                <li className="mb-0"><span className="text-dark h5 me-2"><AiOutlineCheckCircle className="align-middle"/></span><span style={{ color:'#40403f' }}><b>Inclusive Protection:</b></span> Our goal is to empower access to products and strategies that create opportunities for financial success for all.</li>
                                <li className="mb-0"><span className="text-dark h5 me-2"><AiOutlineCheckCircle className="align-middle"/></span><span style={{ color:'#40403f' }}><b>Industry Transformation:</b></span> We aim to look for opportunities to influence our industry by promoting equitable practices that reflect our commitment to fairness and innovation.</li>
                                <li id="values" className="mb-0"><span className="text-dark h5 me-2"><AiOutlineCheckCircle className="align-middle"/></span><span style={{ color:'#40403f' }}><b>Generational Impact:</b></span> We work to empower economic stability and lasting generational wealth through proactive financial planning.</li>
                            </ul>                         
                        </div>
                    </div>
                </div><hr></hr>

                

                <div className="row align-items-center mt-5 mb-5">
                    <div className="col-lg-5 col-md-6">
                        <img src={about3} className="img-fluid rounded shadow" alt=""/>
                    </div>
                    <div className="col-lg-7 col-md-6 mt-4 pt-2 mt-sm-0 pt-sm-0">
                        <div className="section-title ms-lg-5">
                        <h3 className="title mb-3">Our Values</h3>
                        <p className="text-muted2">We stand for accessibility, trust, and advocacy. We recognize that insurance is more than just a policy, <b>it’s a promise of security for those we love.</b> We dedicate our time to ensure every family, regardless of background or financial standing, has the opportunity to protect their future to the best of our ability. </p>
                        <ul className="list-unstyled text-muted2 mb-0">
                                <li className="mb-0"><span className="text-dark h5 me-2"><AiOutlineCheckCircle className="align-middle"/></span><span style={{ color:'#40403f' }}><b>Advocacy:</b> </span>We champion fairness, inclusivity, and equitable access to financial protection strategies for all.</li>
                                <li className="mb-0"><span className="text-dark h5 me-2"><AiOutlineCheckCircle className="align-middle"/></span><span style={{ color:'#40403f' }}><b>Education:</b></span> We prioritize transparency and education, empowering our clients to take control of their financial destinies.</li>
                                <li id="non-discrimination-statement" className="mb-0"><span className="text-dark h5 me-2"><AiOutlineCheckCircle className="align-middle"/></span><span style={{ color:'#40403f' }}><b>Resilience:</b> </span>We are dedicated to helping our clients establish lasting financial resilience.</li>
                        </ul>                         
                        </div>
                    </div>
                </div>


                </div>

                
            
        </section>
        <FooterThree/>
        <ScrollTop/>
        </>
    )
}